import { FC, useEffect, useState } from 'react'
import { Counter } from '../counter'
import { CounterContainer } from './styled'

type Props = {
  value: string
}

export const YearCounter: FC<Props> = ({ value }) => {
  const [displayedValue, setDisplayedValue] = useState('1953')

  useEffect(() => {
    if (value) {
      setDisplayedValue(value)
    }
  }, [value])

  return (
    <CounterContainer
      isEmpty={!displayedValue}
      disabled={!!displayedValue && !value}
    >
      <Counter value={displayedValue || '0000'} animated />
    </CounterContainer>
  )
}
